import { useCallback } from 'react';
import { useOpened, UseOpenedReturnValue } from '../useOpened/useOpened';
import { useRefWithCurrentValue } from '../useRefWithCurrentValue';

export function useModalOpened(
  options: UseModalOpenedOptions
): UseModalOpenedReturnValue {
  const optionsRef = useRefWithCurrentValue(options);
  const { opened, setOpened, close, open } = useOpened();

  const handleBackdropClick = useCallback(() => {
    if (optionsRef.current.closeOnBackDropClick !== false) {
      close();
    }
  }, [optionsRef, close]);

  return {
    opened,
    setOpened,
    close,
    open,
    modalProps: {
      opened,
      onBackdropClick: handleBackdropClick
    }
  };
}

export type UseModalOpenedOptions = {
  /** default: true */
  closeOnBackDropClick?: boolean;
};

export type UseModalOpenedReturnValue = UseOpenedReturnValue & {
  modalProps: ModalProps;
};

export type ModalProps = {
  opened: boolean;
  onBackdropClick: () => void;
};
